import React from "react";
import { Utils } from "../utils/Utils";
import utils from '../lib/utils';
import { COURSE, COURSE_API } from "../utils/Req";
import "../static/css/FM.scss";
import lottie from "lottie-web";

export default class FM extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // 一共会有三个页面： level 列表页、播放列表页、收藏夹（会有收藏夹为空和不为空的情况）。都由参数传递
      showSongList: false,
      showFavorites: false,
      levelList: null,
      // 利用当前是否有歌曲来显示下面的控制
      currentSong: null,
      // 是否播放
      play: false,
      // 当前的播放
      currentPlayList: null,
      // 是否循环
      circle: true,
      currentSongInfo: null,
      // 当前的封面
      currentImage: "",
      nullFavorites: false,
      // 当前播放的时间和总时长
      playTotalTime: 0,
      playCurrentTime: 0,
      tips: ""
      // 无用状态
      // collectList: null,
      // currentSongName: "",
      // currentLike: true,
      // songListData: null,
      // currentSongId: "",
    };

    this.PutaoID = Utils.getCookie("putaoid");
    this.Token = encodeURIComponent(Utils.getCookie("token"));

    this.hashChangeHandler = this.hashChangeHandler.bind(this);
  }

  componentDidMount() {
    // 添加 hashChange 事件
    this.hashChangeHandler();
    this.addHashChangeHandler();
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.hashChangeHandler);
  }

  // 添加 hash 改变的事件
  addHashChangeHandler() {
    window.addEventListener("hashchange", this.hashChangeHandler, false);
  }

  //  在这里获取 url 中的参数，判断是否显示播放列表和收藏夹。
  hashChangeHandler() {
    this.level = Utils.getHashQueryString("level");
    this.favorites = Utils.getHashQueryString("favorites");

    // 获取level 列表
    if (!this.level && !this.favorites) {
      fetch(
        `${COURSE_API.song_home}?putaoid=${this.PutaoID}&token=${
        this.Token
        }&from=pc`,
        { method: "GET" }
      )
        .then(res => res.json())
        .then(data => {
          if (data.code === 200) {
            this.setState({
              levelList: data.items,
              currentPlayList: null
            });
          } else if (data.code === 499) {
            window.location = `${window.location.pathname}${window.location.search}#/login?redirect=FM`;
          }
        });
    }

    // 获取播放列表
    if (this.level && !this.favorites) {
      const req = `${COURSE_API.new_song_list}?putaoid=${this.PutaoID}&token=${
        this.Token
        }&level=${this.level}&from=pc`;
      fetch(req, { method: "GET" })
        .then(res => res.json())
        .then(data => {
          if (data.code === 200 && data.data && data.data.length) {
            let _currentPlayList = null;
            for (let i = 0, len = data.data.length; i < len; i++) {
              let item = data.data[i];
              if (item && item.level === parseInt(this.level, 10)) {
                _currentPlayList = item.list;
                break;
              }
            }
            this.setState({
              currentPlayList: _currentPlayList,
              showSongList: true,
              nullFavorites: false
            }, () => {
              !this.state.play && _currentPlayList[0] && this.playSongHandler(0, _currentPlayList[0].songId);
            });
          } else if (data.code === 499) {
            this.setState({ showSongList: false });
            window.location = `${window.location.pathname}${window.location.search}#/login?redirect=FM`;
          }
        });
    } else {
      this.setState({ showSongList: false });
    }

    // 获取收藏列表
    if (this.favorites && this.level) {
      const req = `${COURSE_API.song_list}?putaoid=${this.PutaoID}&token=${
        this.Token
        }&level=${this.level}&start=0&count=10&type=collection&from=pc`;
      fetch(req, { method: "GET" })
        .then(res => res.json())
        .then(data => {
          if (data.code === 200) {
            if (data.data !== null) {
              this.setState({
                currentPlayList: data.data,
                showFavorites: true
              });
            } else {
              this.setState({
                showFavorites: true,
                nullFavorites: true
              });
            }
          } else if (data.code === 499) {
            window.location = `${window.location.pathname}${window.location.search}#/login?redirect=FM`;
          }
        });
    } else {
      this.setState({ showFavorites: false });
    }
  }

  // 播放歌曲
  playSongHandler(index, id) {
    const { currentPlayList, currentSong } = this.state;

    if (currentSong && currentSong === index) {
      return;
    }

    this.audioElement = document.getElementById("audioSong");

    this.handlePlayError();

    // 给 audio 添加播放监听事件
    this.audioElement.addEventListener(
      "timeupdate",
      () => {
        this.updateProgress();
      },
      false
    );

    // 添加动画
    this.addTaotaoPlayingPiano();

    this.setState({
      play: true,
      currentSong: index,
      currentSongInfo: currentPlayList[index],
      currentImage: currentPlayList[index].coverImgUrl || "",
    });
    this.audioElement.src = currentPlayList[index].audioUrl;
  }

  audioOnPlayHandler() {
    this.setState({
      play: true
    })
  }

  handlePlayError() {
    if (this.audioElement) {
      let playPromise = this.audioElement.play();
      if (playPromise !== undefined) {
        playPromise.then(_ => {

        })
          .catch(error => {
            // utils.showTips("检测到浏览器无法自动播放，点击这里继续", -1, () => {
            //   this.handlePlayError();
            // });
            this.setState({
              play: false
            })
          });
      }
    }
  }

  addTaotaoPlayingPiano() {
    this.taotao_piano = document.getElementById("taotao-piano");
    if (this.taotao_piano) {
      console.log("动画");
      lottie.loadAnimation({
        container: this.taotao_piano, //包含动画的DOM元素
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: window.publicUrl + "static/lottie/taotao_piano.json" //动画的路径
      });
    }
  }

  pauseTaotaoPlayingPiano() {
    this.taotao_piano = this.audioElement;
    if (this.taotao_piano) {
      console.log("动画");
      lottie.loadAnimation({
        container: this.taotao_piano, //包含动画的DOM元素
        renderer: "svg",
        loop: true,
        autoplay: false,
        path: window.publicUrl + "static/lottie/taotao_piano.json" //动画的路径
      });
    }
  }

  // 更新进度条与当前播放的时间
  updateProgress() {
    this.setState({
      playCurrentTime: this.audioElement.currentTime,
      playTotalTime: this.audioElement.duration
    });
  }

  //  修改进度
  mouseDownProgresBarHandler(e) {
    if (!this.audioElement.paused || this.audioElement.currentTime !== 0) {
      const containerLeft = document.querySelector(".progress-container")
        .offsetLeft;
      const progressWidth = document.querySelector(".progress-background")
        .clientWidth;
      const mouseDownLeft = e.clientX - containerLeft;

      this.audioElement.currentTime =
        this.audioElement.duration * (mouseDownLeft / progressWidth);
    }
  }

  audioOnEndedHandler() {
    const { circle, play } = this.state;
    if (this.audioElement && this.audioElement.paused && play) {
      if (circle) {
        console.log("顺序循环", this.state.currentSong);
        this.changeSongHandler(1);
      } else {
        console.log("单曲循环");
        this.changeSongHandler(0);
      }
    }
  }

  // 控制是否播放歌曲
  songControlHandler() {
    const { play } = this.state;
    this.setState({
      play: !play
    });

    if (play) {
      this.audioElement.pause();
      this.pauseTaotaoPlayingPiano();
    } else {
      this.audioElement.play();
      this.addTaotaoPlayingPiano();
    }
  }

  // 上一曲与下一曲
  changeSongHandler(step) {
    const { currentSong, currentPlayList } = this.state;
    let tempSomngIndex = null;

    if (step === 0) {
      tempSomngIndex = currentSong;
    }
    if (step > 0) {
      if (currentSong < currentPlayList.length - 1) {
        tempSomngIndex = currentSong + 1;
      } else {
        tempSomngIndex = 0;
      }
    }

    if (step < 0) {
      if (currentSong > 0 && currentSong <= currentPlayList.length - 1) {
        tempSomngIndex = currentSong - 1;
      } else {
        tempSomngIndex = currentPlayList.length - 1;
      }
    }

    this.setState({
      play: true,
      currentSong: tempSomngIndex,
      currentSongInfo: currentPlayList[tempSomngIndex],
      currentImage: currentPlayList[tempSomngIndex].coverImgUrl || "",
    });

    this.addTaotaoPlayingPiano();

    this.audioElement.src = currentPlayList[tempSomngIndex].audioUrl;
  }

  // 歌曲收藏
  collectHandler(id, action) {
    const req = `${COURSE_API.song_collect}?putaoid=${this.PutaoID}&token=${
      this.Token
      }&songid=${id}&action=${action}&from=pc`;

    fetch(req, {
      method: "GET"
    })
      .then(req => req.json())
      .then(data => {
        if (data.code === 200) {
          this.hashChangeHandler();
        }
      });

    if (action === "add") {
      this.setState({
        currentSongInfo: Object.assign({}, this.state.currentSongInfo, {
          collect: true
        })
      });
      this.addToast("收藏成功");
    } else {
      this.setState({
        currentSongInfo: Object.assign({}, this.state.currentSongInfo, {
          collect: false
        })
      });
      this.addToast("取消收藏");
    }
  }

  // 点击列表循环和单曲循环
  circlePlayHandler() {
    const { circle } = this.state;
    if (circle) {
      this.addToast("单曲循环");
    } else {
      this.addToast("列表循环");
    }
    this.setState({
      circle: !circle
    });
  }

  // 将秒数转化为分钟：秒
  changeSecondsToMinutes(second) {
    if (second) {
      const minute = Math.floor(second / 60);
      const seconds =
        Math.floor(Math.floor(second % 60) / 10) === 0
          ? `0${Math.floor(second % 60)}`
          : Math.floor(second % 60);
      return `${minute}:${seconds}`;
    }
    return null;
  }

  // 改变 url
  changeWindowLocation(params) {
    window.location = `${window.location.pathname}${window.location.search}#/FM${params}`;
  }

  // 添加提示
  addToast(text) {
    this.setState({ tips: text });
    this.timer = setTimeout(() => {
      this.setState({
        tips: ""
      });
    }, 2000);
  }

  render() {
    const {
      play,
      showFavorites,
      showSongList,
      currentSong,
      currentImage,
      levelList,
      currentPlayList,
      currentSongInfo,
      circle,
      nullFavorites,
      playCurrentTime,
      playTotalTime,
      tips
    } = this.state;

    return (
      <div className="FM-container">
        {tips && <div className="FM-container-tips">{tips}</div>}
        {levelList &&
          !currentPlayList &&
          (!showSongList && !showFavorites) &&
          Array.isArray(levelList) && (
            <div className="level-list-container">
              {levelList.map((value, index) => (
                <div className="level-card" key={index}>
                  <div
                    className="level-card-background"
                    style={{
                      background: `url(${value.image}) no-repeat center / cover`
                    }}
                    onClick={() => {
                      this.changeWindowLocation(`?level=${value.level}`);
                    }}
                  />
                  <div className="level-card-level">Level{value.level}</div>
                  <div className="level-card-title">
                    {value.name}
                    <span className="level-card-title-num">{`(${
                      value.numbers
                      })`}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

        {(showSongList || showFavorites) && currentPlayList && !nullFavorites && (
          <div className="big-container">
            {
              <div className="song-list-title">
                {showSongList ? (
                  <ul className="song-level">
                    <li className={this.level === "0" ? "active" : ""} onClick={() => {
                      window.location.replace("#/FM?level=0");
                    }}>Level K</li>
                    <li className={this.level === "1" ? "active" : ""} onClick={() => {
                      window.location.replace("#/FM?level=1");
                    }}>Level 1</li>
                    <li className={this.level === "2" ? "active" : ""} onClick={() => {
                      window.location.replace("#/FM?level=2");
                    }}>Level 2</li>
                    <li className={this.level === "3" ? "active" : ""} onClick={() => {
                      window.location.replace("#/FM?level=3");
                    }}>Level 3</li>
                  </ul>
                ) : null}

                {showSongList ? "" : `我的收藏夹(${currentPlayList.length})`}

                {/* {showSongList ? "葡萄FM" : "我的收藏夹"}
                {showSongList ? (
                  <span style={{ color: "#6f6979" }}>{`(${
                    currentPlayList.length
                    })`}</span>
                ) : null} */}
              </div>
            }
            <div className="song-list-container">
              {currentImage ?
                <div className="song-picture">
                  <div
                    className={play ? "song-bg turn" : "song-bg"}
                    style={{
                      background: `url(${currentImage}) no-repeat center / contain`
                    }} />
                </div>
                : null
              }
              {/* <div className="song-list-box"> */}
              <ul className="song-list">
                {Array.isArray(currentPlayList) &&
                  currentPlayList.map((value, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        this.playSongHandler(index, value.songId);
                      }}
                      style={{
                        color:
                          currentSongInfo &&
                          currentSongInfo.songId === value.songId &&
                          '#f19536'
                      }}
                    >
                      {value.collect && <div className="song-like" />}
                      <span>{index + 1}</span>
                      <div className="song-name">{value.title}</div>
                      <div className="song-info-container">
                        {
                          value.author ?
                            <div>{value.author}</div>
                            : <div />
                        }
                        <div>{this.changeSecondsToMinutes(value.duration)}</div>
                        <div
                          style={{
                            background:
                              currentSongInfo &&
                              currentSongInfo.songId === value.songId &&
                              `url(${require("../static/img/FM/play-orange.png")}) no-repeat center / contain`
                          }}
                        />
                      </div>
                    </li>
                  ))}
              </ul>
              {/* </div> */}
            </div>
          </div>
        )}

        {showFavorites && nullFavorites && (
          <div className="null-favorites-container">
            <div className="">我的收藏夹</div>
            <div className="null-favorites" />
            <div>收藏夹是空的呦~</div>
          </div>
        )}

        {currentSong !== null && (
          <div className="playing-container">
            <div className="playing-name">
              {currentSong + 1}.{currentSongInfo.title}
            </div>
            <div className="progress-container">
              <div
                className="progress-box"
                onMouseDown={e => {
                  this.mouseDownProgresBarHandler(e);
                }}
              >
                <div className="progress-background">
                  <div
                    className="progress-bar"
                    style={{
                      width:
                        this.audioElement &&
                        `${Math.floor(
                          (playCurrentTime / playTotalTime) * 100
                        )}%`
                    }}
                  />
                </div>
              </div>
              <div className="progress-time">
                {this.changeSecondsToMinutes(playCurrentTime)}/
                {this.changeSecondsToMinutes(playTotalTime)}
              </div>
            </div>
            <div className="playing-control-container">
              <div
                className="playing-control-like"
                onClick={() => {
                  currentSongInfo &&
                    (currentSongInfo.collect
                      ? this.collectHandler(currentSongInfo.songId, "cancel")
                      : this.collectHandler(currentSongInfo.songId, "add"));
                }}
                style={{
                  background:
                    currentSongInfo.collect &&
                    `url(${require("../static/img/FM/like.png")}) no-repeat center / 72%`
                }}
              />
              <div
                className="playing-control-prev"
                onClick={() => {
                  this.changeSongHandler(-1);
                }}
              />
              <div
                className="playing-control-play"
                style={{
                  background:
                    play &&
                    `url(${require("../static/img/FM/pause.png")}) no-repeat center / contain`
                }}
                onClick={() => {
                  this.songControlHandler();
                }}
              />
              <div
                className="playing-control-next"
                onClick={() => {
                  this.changeSongHandler(1);
                }}
              />
              <div
                className="playing-control-way"
                style={{
                  background: circle
                    ? `url(${require("../static/img/FM/play-xunhuan.png")}) no-repeat center / contain`
                    : `url(${require("../static/img/FM/circle.png")}) no-repeat center / contain`
                }}
                onClick={() => {
                  this.circlePlayHandler();
                }}
              />
            </div>
          </div>
        )}

        <audio
          id="audioSong"
          autoPlay
          onEnded={() => {
            this.audioOnEndedHandler();
          }}
          onPlay={() => {
            this.audioOnPlayHandler();
          }}
        />

        <div
          className="FM-back"
          onClick={() => {
            window.history.back();
          }}
        />
        {!showFavorites && (
          <div
            className="FM-favorites"
            onClick={() => {
              this.changeWindowLocation(
                `?level=${this.level ? this.level : 1}&favorites=${true}`
              );
            }}
          />
        )}

        <div className="playing-left-flower" />
        <div id="taotao-piano" />
        <div className="playing-right-book" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/route/FM.js